// Environmental Sustainability Skills organized by subcategories
export const ENVIRONMENTAL_SUSTAINABILITY_SKILLS_CATEGORIES = [
  {
    name: 'Environmental Assessment',
    skills: [
      'Environmental Impact Assessment', 'Carbon Footprint Analysis', 'Ecological Assessment',
      'Resource Consumption Analysis', 'Waste Audit', 'Energy Efficiency Assessment',
      'Water Quality Testing', 'Air Quality Monitoring', 'Biodiversity Assessment',
      'Environmental Risk Assessment', 'Sustainability Metrics', 'Life Cycle Assessment',
      'Environmental Monitoring', 'Data Collection', 'Impact Evaluation'
    ]
  },
  {
    name: 'Resource Management',
    skills: [
      'Natural Resource Management', 'Water Conservation', 'Energy Management',
      'Waste Reduction', 'Material Recovery', 'Sustainable Procurement',
      'Resource Efficiency', 'Circular Economy', 'Supply Chain Optimization',
      'Resource Planning', 'Inventory Management', 'Conservation Strategies',
      'Resource Allocation', 'Usage Monitoring', 'Efficiency Programs'
    ]
  },
  {
    name: 'Renewable Energy',
    skills: [
      'Solar Energy Systems', 'Wind Power Technology', 'Hydroelectric Systems',
      'Geothermal Energy', 'Biomass Energy', 'Energy Storage',
      'Grid Integration', 'System Design', 'Installation Management',
      'Performance Monitoring', 'Maintenance Planning', 'Efficiency Optimization',
      'Project Development', 'Cost Analysis', 'Technology Assessment'
    ]
  },
  {
    name: 'Waste Management',
    skills: [
      'Waste Reduction', 'Recycling Programs', 'Composting Systems',
      'Hazardous Waste Management', 'Zero Waste Planning', 'Waste Auditing',
      'Material Recovery', 'Waste Treatment', 'Disposal Management',
      'Program Implementation', 'Compliance Monitoring', 'Data Tracking',
      'Process Optimization', 'Staff Training', 'Public Education'
    ]
  },
  {
    name: 'Environmental Policy',
    skills: [
      'Policy Development', 'Regulatory Compliance', 'Environmental Law',
      'Policy Analysis', 'Stakeholder Engagement', 'Policy Implementation',
      'Impact Assessment', 'Compliance Monitoring', 'Policy Evaluation',
      'Risk Management', 'Documentation', 'Reporting Requirements',
      'Policy Updates', 'Training Programs', 'Communication Strategy'
    ]
  },
  {
    name: 'Sustainable Design',
    skills: [
      'Green Building Design', 'Eco-friendly Products', 'Sustainable Materials',
      'Life Cycle Design', 'Energy Efficiency', 'Water Conservation',
      'Waste Reduction', 'Environmental Impact', 'Cost Analysis',
      'Performance Metrics', 'Innovation Integration', 'Design Standards',
      'Project Management', 'Quality Control', 'Documentation'
    ]
  },
  {
    name: 'Climate Change',
    skills: [
      'Climate Science', 'Emissions Reduction', 'Adaptation Strategies',
      'Mitigation Planning', 'Risk Assessment', 'Impact Analysis',
      'Policy Development', 'Data Analysis', 'Reporting Systems',
      'Project Management', 'Stakeholder Engagement', 'Communication',
      'Research Methods', 'Technology Assessment', 'Program Development'
    ]
  },
  {
    name: 'Conservation',
    skills: [
      'Biodiversity Protection', 'Habitat Restoration', 'Species Management',
      'Land Conservation', 'Water Conservation', 'Resource Protection',
      'Program Development', 'Monitoring Systems', 'Data Collection',
      'Impact Assessment', 'Stakeholder Engagement', 'Project Management',
      'Research Methods', 'Documentation', 'Public Education'
    ]
  },
  {
    name: 'Environmental Education',
    skills: [
      'Program Development', 'Curriculum Design', 'Training Delivery',
      'Public Outreach', 'Workshop Facilitation', 'Material Development',
      'Impact Assessment', 'Program Evaluation', 'Stakeholder Engagement',
      'Communication Strategy', 'Resource Development', 'Event Planning',
      'Research Integration', 'Documentation', 'Continuous Improvement'
    ]
  },
  {
    name: 'Sustainable Agriculture',
    skills: [
      'Organic Farming', 'Soil Conservation', 'Water Management',
      'Pest Management', 'Crop Rotation', 'Sustainable Practices',
      'Resource Efficiency', 'Biodiversity Protection', 'Waste Reduction',
      'Program Development', 'Quality Control', 'Documentation',
      'Research Methods', 'Training Programs', 'Impact Assessment'
    ]
  },
  {
    name: 'Green Technology',
    skills: [
      'Clean Energy Systems', 'Environmental Monitoring', 'Efficiency Technologies',
      'Waste Treatment', 'Water Treatment', 'Air Quality Control',
      'System Design', 'Implementation', 'Performance Monitoring',
      'Data Analysis', 'Cost Assessment', 'Technology Evaluation',
      'Innovation Management', 'Documentation', 'Training Programs'
    ]
  },
  {
    name: 'Environmental Compliance',
    skills: [
      'Regulatory Knowledge', 'Compliance Monitoring', 'Audit Management',
      'Documentation Control', 'Reporting Systems', 'Risk Assessment',
      'Training Programs', 'Policy Implementation', 'Quality Control',
      'Data Management', 'Performance Metrics', 'Continuous Improvement',
      'Stakeholder Communication', 'Program Development', 'Impact Assessment'
    ]
  },
  {
    name: 'Sustainable Transportation',
    skills: [
      'Electric Vehicle Systems', 'Public Transit Planning', 'Alternative Fuels',
      'Infrastructure Development', 'Efficiency Programs', 'Emissions Reduction',
      'Route Optimization', 'Cost Analysis', 'Impact Assessment',
      'Program Management', 'Data Collection', 'Performance Monitoring',
      'Stakeholder Engagement', 'Policy Development', 'Implementation Strategy'
    ]
  },
  {
    name: 'Water Management',
    skills: [
      'Water Conservation', 'Quality Control', 'Treatment Systems',
      'Distribution Management', 'Efficiency Programs', 'Usage Monitoring',
      'System Maintenance', 'Data Analysis', 'Compliance Management',
      'Project Planning', 'Risk Assessment', 'Documentation',
      'Staff Training', 'Public Education', 'Program Evaluation'
    ]
  },
  {
    name: 'Corporate Sustainability',
    skills: [
      'Strategy Development', 'Program Implementation', 'Performance Metrics',
      'Stakeholder Engagement', 'Reporting Systems', 'Risk Management',
      'Policy Development', 'Training Programs', 'Impact Assessment',
      'Data Analysis', 'Communication Strategy', 'Documentation',
      'Quality Control', 'Continuous Improvement', 'Innovation Management'
    ]
  }
];

// Export flattened list for backward compatibility
export const ENVIRONMENTAL_SUSTAINABILITY_SKILLS = ENVIRONMENTAL_SUSTAINABILITY_SKILLS_CATEGORIES.reduce(
  (acc, category) => [...acc, ...category.skills],
  [] as string[]
);
